export function originalOrder(): number {
  return 0;
}
